import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const UserProfileAdd = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.9499 6.00002C7.9499 4.42601 9.22589 3.15002 10.7999 3.15002C12.3739 3.15002 13.6499 4.42601 13.6499 6.00002C13.6499 7.57404 12.3739 8.85002 10.7999 8.85002C9.22589 8.85002 7.9499 7.57404 7.9499 6.00002ZM10.7999 1.65002C8.39746 1.65002 6.4499 3.59759 6.4499 6.00002C6.4499 8.40246 8.39746 10.35 10.7999 10.35C13.2023 10.35 15.1499 8.40246 15.1499 6.00002C15.1499 3.59759 13.2023 1.65002 10.7999 1.65002ZM6.00031 13.65C3.59806 13.65 1.65058 15.5973 1.65031 17.9995L1.6499 21.5999C1.64986 22.0142 1.9856 22.35 2.39982 22.35C2.81403 22.3501 3.14986 22.0143 3.1499 21.6001L3.15031 17.9997C3.15048 16.4258 4.42642 15.15 6.00031 15.15H8.75C9.16421 15.15 9.5 14.8142 9.5 14.4C9.5 13.9858 9.16421 13.65 8.75 13.65H6.00031ZM19.25 10C19.25 9.58579 18.9142 9.25 18.5 9.25C18.0858 9.25 17.75 9.58579 17.75 10V13.7502H14C13.5858 13.7502 13.25 14.086 13.25 14.5002C13.25 14.9144 13.5858 15.2502 14 15.2502H17.75V19C17.75 19.4142 18.0858 19.75 18.5 19.75C18.9142 19.75 19.25 19.4142 19.25 19V15.2502H23C23.4142 15.2502 23.75 14.9144 23.75 14.5002C23.75 14.086 23.4142 13.7502 23 13.7502H19.25V10Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default UserProfileAdd
